export const useCSRFToken = () => {
  const cookie = useCookie<Maybe<string>>('XSRF-TOKEN')
  const token = computed<Maybe<string>>(() => cookie.value || null)

  const getCSRFToken = async (force: boolean = false): Promise<void> => {
    if (!force && !token.value) {
      return
    }

    await useApiGet('/sanctum/csrf-cookie')
  }

  const clear = () => {
    cookie.value = null
  }

  return {
    token,
    clear,
    getCSRFToken,
  }
}
